import { render, staticRenderFns } from "./BulkActionArgsModal.vue?vue&type=template&id=0db18c36&scoped=true&"
import script from "./BulkActionArgsModal.vue?vue&type=script&lang=ts&"
export * from "./BulkActionArgsModal.vue?vue&type=script&lang=ts&"
import style0 from "./BulkActionArgsModal.vue?vue&type=style&index=0&id=0db18c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db18c36",
  null
  
)

export default component.exports